import {
  Component,
  Input,
  OnChanges,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { MobileComponent } from "../../../mobile/interface/mobile.component";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "src/app/shared/module/material.module";
import { TableUtilityService } from "../../service/utility/table-utility.service";
import { MatChipsModule } from "@angular/material/chips";
import { IconComponent } from "../../../icon/icon.component";

@Component({
  selector: "rfc-icon-chips-text",
  templateUrl: "./icon-chips-text.component.html",
  styleUrls: ["./icon-chips-text.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    MatChipsModule,
    IconComponent,
    
  ],
  providers: [TableUtilityService],
})
export class IconChipsTextComponent
  extends MobileComponent
  implements OnChanges
{
  @Input() ict;

  constructor() {
    super();
  }
  ngOnChanges() {}

  getBarClass(color, size) {
    console.log(color, size);
    return { backgroundColor: color, height: 100 / size + "%" };
  }

  getClassChip(ict) {
    return "chip " + ict.chipClass;
  }
}
